// extracted by mini-css-extract-plugin
export default {"root":"IconChemistry_root__bzKIn"};